import { Component, ViewChild } from "@angular/core";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { EntityListAction } from "projects/sepidz-web-framework/src/lib/models";
import { LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { ProductConversionStandardFormComponent } from "../product-conversion-standard-form/product-conversion-standard-form.component";
@Component({
  selector: "ngx-product-conversion-standard-list",
  templateUrl: "./product-conversion-standard-list.component.html",
  styleUrls: ["./product-conversion-standard-list.component.scss"],
})
export class ProductConversionStandardListComponent extends BaseListComponent {
  actions: EntityListAction[];
  @ViewChild("grid") grid: KGridComponent;
  constructor(private lookupservice: LookupService) {
    super();
    this.inputEditorform = ProductConversionStandardFormComponent;
  }
  ngOnInit() {
    this.apiName = "ProductConversionStandardHeader";
    this.areaName = "Inventory";
    this.label = this.translate("ClientApp.Pages.PageMenu.ProductConversionStandardTitle");
  }
}
